package landing.ui

import androidx.compose.foundation.layout.*
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import loadResourceString
import truematchmp.composeapp.generated.resources.Res
import truematchmp.composeapp.generated.resources.feedback
import truematchmp.composeapp.generated.resources.privacy_policy
import truematchmp.composeapp.generated.resources.term_of_service

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun LinksPanel(
    modifier: Modifier = Modifier,
) {
    FlowRow(
        horizontalArrangement = Arrangement.SpaceAround,
        modifier = modifier,
    ) {
        val uriHandler = LocalUriHandler.current
        TmTextButton(
            modifier = Modifier,
            enabled = true,
            onClick = { uriHandler.openUri(PRIVACY_POLICY_URL) },
        ) {
            Text(
                text = loadResourceString(Res.string.privacy_policy),
            )
        }
        TmTextButton(
            enabled = true,
            modifier = Modifier,
            onClick = { uriHandler.openUri(TERM_OF_SERVICE) },
        ) {
            Text(text = loadResourceString(Res.string.term_of_service))
        }
        TmTextButton(
            enabled = true,
            modifier = Modifier,
            onClick = { uriHandler.openUri(FEEDBACK_URL) },
        ) {
            Text(text = loadResourceString(Res.string.feedback))
        }
    }
}
/**
 * Now in Android text button with generic content slot. Wraps Material 3 [TextButton].
 *
 * @param onClick Will be called when the user clicks the button.
 * @param modifier Modifier to be applied to the button.
 * @param enabled Controls the enabled state of the button. When `false`, this button will not be
 * clickable and will appear disabled to accessibility services.
 * @param content The button content.
 */
@Composable
fun TmTextButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    content: @Composable RowScope.() -> Unit,
) {
    TextButton(
        onClick = onClick,
        modifier = modifier,
        enabled = enabled,
        colors = ButtonDefaults.textButtonColors(
            contentColor = Color.White,
        ),
        content = content,
    )
}


private const val PRIVACY_POLICY_URL = "./privacy"
private const val TERM_OF_SERVICE = "./term"
private const val FEEDBACK_URL = "mailto:orispok@truematch.life"